import { z } from 'zod';

/////////////////////////////////////////
// CODE ENFORCEMENT ATTACHMENT SCHEMA
/////////////////////////////////////////

export const CodeEnforcementAttachmentSchema = z.object({
  attachmentId: z.number().int(),
  cityId: z.number().int(),
  caseId: z.number().int(),
  name: z.string().nullable(),
  note: z.string(),
  location: z.string(),
  fileType: z.string(),
  fileSize: z.number().int(),
  dateEntered: z.coerce.date(),
  imageType: z.string(),
  archived: z.number().int(),
  version: z.number().int().nullable(),
  externalId: z.string().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type CodeEnforcementAttachment = z.infer<typeof CodeEnforcementAttachmentSchema>

export default CodeEnforcementAttachmentSchema;
